module.exports = __webpack_public_path__ + "static/img/1000000435.a5f75247.jpg";